/*
 * Release
 */

import Crud from '../crud';
const crud = new Crud('release');

// State
const state = {
    ...crud.state
}

// Getters
const getters = {
    ...crud.getters
}

// Actions
const actions = {
    ...crud.actions
}

// Mutations
const mutations = {
    ...crud.mutations
}

// Export module
const Release = {
    state,
    getters,
    actions,
    mutations,
    namespaced: true,
}
export default Release
export { Release }
